import {
  FormLabel,
  TextField,
  Typography,
  FormControl,
  type SxProps,
} from '@mui/material';
import { useState } from 'react';

import type { FieldValidation } from './validation/fieldValidation';
import { InputErrorIcon } from './validation/inputErrorIcon';

export const FormTextField = ({
  testId,
  title,
  dataTestId,
  validation,
  placeholder,
  value,
  onChange,
  sx,
}: {
  testId?: string;
  title: string;
  dataTestId?: string;
  validation?: FieldValidation;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps;
}) => {
  const [touched, setTouched] = useState(false);
  const hasError =
    touched && (validation ? !validation.validateInput(value) : false);

  return (
    <FormControl sx={{ width: '100%', ...sx }}>
      {title && (
        <FormLabel>
          <Typography variant='subtitle1'>{title}</Typography>
        </FormLabel>
      )}
      <TextField
        data-testid={testId}
        onBlur={() => setTouched(true)}
        error={hasError}
        sx={{
          '& .MuiInputBase-root': {
            paddingRight: hasError ? '4px' : '24px',
          },
        }}
        inputProps={{
          ...(dataTestId ? { 'data-testid': dataTestId } : {}),
          style: { height: '24px' },
        }}
        InputProps={{
          endAdornment: hasError && (
            <InputErrorIcon errorMessage={validation?.errorMessage} />
          ),
        }}
        placeholder={placeholder}
        disabled={false}
        value={value}
        onChange={onChange}
      />
    </FormControl>
  );
};
